<div
    class="bg-white transition-all flex flex-col border border-gray-100 shadow-sm rounded-xl"
>
    <button
        (click)="toggle()"
        [class.border-b]="open()"
        class="hover:bg-gray-50 border-gray-100 transition-colors flex p-4 w-full justify-between"
    >
        <div class="flex gap-2 items-center">
            <app-icon name="material-symbols:folder" class="text-primary-200" />
            <p class="font-medium">{{ title() }}</p>
        </div>
        @if (open()) {
            <app-icon name="mdi:chevron-up" />
        } @else {
            <app-icon name="mdi:chevron-down" />
        }
    </button>
    @if (open()) {
        <div
            animate.enter="acccordian-slide-y-in"
            animate.leave="acccordian-slide-y-out"
            class="p-4"
        >
            <ng-content />
        </div>
    }
</div>
